import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal  } from '@ng-bootstrap/ng-bootstrap';
import { IModalData } from '@core/interfaces/imodal-data';

@Component({
    selector: 'app-confirm-cancel',
    templateUrl: './confirm-cancel.component.html',
    styleUrls: ['./confirm-cancel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmCancelComponent {
  constructor(public modal: NgbActiveModal) {}

  @Input() data!: IModalData;
  defaultText: IModalData = {
    title: 'Confirm Action',
    body: 'Please confirm your action.',
    cancelBtnText: 'Cancel',
    confirmBtnText: 'Confirm'
  }
}
